// extracted by mini-css-extract-plugin
export default {"titleContainer":"title_titleContainer__19vqn","title":"title_title__jb+Dr","hr":"title_hr__33Ca1"};